import React from "react";
import { Link } from "react-router-dom";
import { MESSAGES, STAGES } from "../content";
import { CtaBand, PageHead, PageTop, useSeo } from "../ui";

export default function Process() {
  useSeo({
    title: "진행 방식 — 아이디어 검토 · PoC · MVP · 양산 설계 · 양산 | I.META",
    description:
      "아이디어 검토(1주 내 · 무료) → PoC → MVP → 양산 설계 → 양산·공급. 각 단계가 끝날 때마다 계속할지 결정합니다. 큰돈을 한 번에 걸지 않아도 됩니다. 시제품 제작, 하드웨어 개발, 양산.",
    path: "/process",
  });

  return (
    <>
      <PageTop>
        <PageHead kicker="HOW WE WORK · 진행 방식" title={MESSAGES.support.proof} />
      </PageTop>

      {/* 단계별 타임라인 — 단계 · 내용 · 기간 · 비용 */}
      <section className="section section--tight">
        <ol className="steps">
          {STAGES.map((s) => (
            <li key={s.step} className="step">
              <div className="step__side">
                <div className="step__no">{s.step}</div>
                <div className="step__line" aria-hidden="true" />
              </div>

              <div className="step__main">
                <h2 className="step__title">{s.title}</h2>
                <p className="step__desc">{s.desc}</p>
                <dl className="step__facts">
                  <div><dt>기간</dt><dd>{s.period}</dd></div>
                  <div><dt>비용</dt><dd>{s.cost}</dd></div>
                </dl>
              </div>
            </li>
          ))}
        </ol>

        <p className="note-line">
          비용 부담은 계약 방식(일반 개발 · Partnership · Venture)에 따라 다릅니다.{" "}
          <Link to="/partnership#models">3가지 계약 방식 보기</Link>
        </p>
      </section>

      <CtaBand />
    </>
  );
}
